export default "__VITE_ASSET___dyAd2Ol__"